import {
  Goal,
  GoalGroupBy,
  GoalRoadmapSortingKeys,
  GoalRoadmapSortingOptions,
  GoalSortingMode,
  GroupByMode,
  ID,
} from '@griply/types';

export type GetProjectsOverviewCustomOrderOptions = {
  goals: Goal[];
  groupBy: GoalGroupBy;
  sortingMode?: GoalSortingMode | null;
  goalRoadmapSorting?: Record<GoalRoadmapSortingOptions, ID[]>;
};

// Grouped projects share their parent goal's `goalSorting`; ungrouped ones follow the roadmap order.
export const getProjectsOverviewCustomOrder = ({
  goals,
  groupBy,
  sortingMode,
  goalRoadmapSorting,
}: GetProjectsOverviewCustomOrderOptions): ID[] | undefined => {
  if (groupBy !== GroupByMode.Goal || sortingMode !== GoalSortingMode.Custom) {
    return undefined;
  }

  return [
    ...goals.flatMap((goal) => goal.goalSorting ?? []),
    ...(goalRoadmapSorting?.[GoalRoadmapSortingKeys.InProgress] ?? []),
  ];
};
